import type { FC } from "react";
import { Link } from "react-router-dom";

import { AuthPageShell, authLinkClass } from "@/pages/auth/AuthPageShell";

export const SignupPage: FC = () => {
  return (
    <AuthPageShell
      testId="signup-page"
      title={
        <span data-testid="signup-title">
          Zephix is in private preview —{" "}
          <a href="https://getzephix.com" className={authLinkClass}>
            request access
          </a>
        </span>
      }
      subtitle={
        <>
          Already have an account?{" "}
          <Link to="/login" className={authLinkClass} data-testid="login-link">
            Sign in
          </Link>
        </>
      }
    >
      {null}
    </AuthPageShell>
  );
};
